
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h3v34H0V0z","fill":"#008F42"}}),_c('path',{attrs:{"d":"M3 0h3v34H3V0z","fill":"#00AB47"}}),_c('path',{attrs:{"d":"M6 0h4v34H6V0z","fill":"#52C638"}}),_c('path',{attrs:{"d":"M10 0h3v34h-3V0z","fill":"#96C65A"}}),_c('path',{attrs:{"d":"M13 0h3v34h-3V0z","fill":"#00C4B5"}}),_c('path',{attrs:{"d":"M16 0h2v34h-2V0z","fill":"#00A2DC"}}),_c('path',{attrs:{"d":"M18 0h3v34h-3V0z","fill":"#0A6CB8"}}),_c('path',{attrs:{"d":"M21 0h3v34h-3V0z","fill":"#46597D"}}),_c('path',{attrs:{"d":"M24 0h4v34h-4V0z","fill":"#FF001A"}}),_c('path',{attrs:{"d":"M28 0h3v34h-3V0z","fill":"#FF6B00"}}),_c('path',{attrs:{"d":"M31 0h3v34h-3V0z","fill":"#F7C000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.5 15.125h1v2.625a2.251 2.251 0 01-4.5 0v-2.625h1v2.625c0 .759.56 1.375 1.25 1.375s1.25-.616 1.25-1.375v-2.625zm5.505 4.75h1V17.25a2.251 2.251 0 00-4.5 0v2.625h1V17.25c0-.759.56-1.375 1.25-1.375s1.25.616 1.25 1.375v2.625zm-14.13 0H6v-2.25h.004A2.077 2.077 0 016 17.5V13h1v2.5A2.501 2.501 0 118.5 20c-.598 0-1.146-.21-1.576-.56l-.05.435zm1.562-4c.863 0 1.563.728 1.563 1.625s-.7 1.625-1.563 1.625c-.862 0-1.562-.728-1.562-1.625s.7-1.625 1.562-1.625zm18.688-.75H28v2.25h-.004c.003.041.004.083.004.125V22h-1v-2.5a2.501 2.501 0 11-1.5-4.5c.598 0 1.146.21 1.576.56l.049-.435zm-1.562 4C24.7 19.125 24 18.397 24 17.5s.7-1.625 1.563-1.625c.862 0 1.562.728 1.562 1.625s-.7 1.625-1.562 1.625z","fill":"#fff"}})])
          )
        }
      }
    